module.exports = __webpack_public_path__ + "img/lnd.110523f5.png";